import store from "../store/index";
//-----------------------------
// get headline marker options
//-----------------------------
export default function getHeadlineMarkerOptions() {
  //-----------------
  // get all markers
  //-----------------
  const this_store = store;
  const markers = this_store.getters["combat/getMarkers"];
  //----------------------
  // get headline markers
  //----------------------
  let headline_markers = markers.filter((a) => a.headline == true);
  return headline_markers;
}
